// extracted by mini-css-extract-plugin
export default {"flexRow":"flex_flexRow__y0UR2","flexColumn":"flex_flexColumn__s48bX"};